import { getCamelCaseWord, market, product_category } from '../../static/brands_wholesalers_data';

// The signup market list, as the fair picks its countries in the app (value = the stored label)
export const MARKET_OPTIONS = market
  .filter((m) => m.label !== 'Open')
  .map((m) => ({ value: m.label, label: getCamelCaseWord(m.label) }));

// Saved countries may differ in case from the list ('Italy' / 'italy'); unknown ones are kept
export const toMarketOptions = (countries = []) =>
  countries.map(
    (name) =>
      MARKET_OPTIONS.find((o) => o.value.toLowerCase() === name.toLowerCase()) || {
        value: name,
        label: getCamelCaseWord(name),
      }
  );

// The app's category list (CategoryPicker: product_category labels)
export const CATEGORY_OPTIONS = product_category.map((c) => ({ value: c.label, label: c.label }));
export const toCategoryOptions = (categories = []) =>
  categories.map((name) => ({ value: name, label: name }));
